<template>
  <div class="header-area">
    <div class="wrap">
      <div class="header-top">
        <h1 class="logo"><router-link to="/usr/main">KHFF 건강기능식품교육센터</router-link></h1>
      </div>
      <el-skeleton :loading="loading" animated>
        <template slot="template">
          <el-skeleton-item style="height: 70px" />
        </template>
        <template>
          <nav class="site-gnb">
            <ul v-if="menus.children != null">
              <li v-for="menu in menus.children" :key="menu.id" v-if="menu.showYn == 'Y'">
                <a @click="goMenu(menu)">{{ menu.text }}</a>
                <ul>
                  <li v-for="sub in menu.children" :key="sub.id" v-if="menu.showYn == 'Y'">
                    <a @click="goMenu(sub)">{{ sub.text }}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          <button type="button" class="btn-nav-open">
            <span class="txt-hide">전체보기 열기</span>
          </button>
        </template>
      </el-skeleton>
    </div>
    <div class="site-nav-area">
      <div class="wrap">
        <nav class="site-nav">
          <ul v-if="menus.children != null">
            <li v-for="menu in menus.children" :key="menu.id" v-if="menu.showYn == 'Y'">
              <a @click="goMenu(menu)">{{ menu.text }}</a>
              <ul>
                <li v-for="sub in menu.children" :key="sub.id" v-if="menu.showYn == 'Y'">
                  <a @click="goMenu(sub)">{{ sub.text }}</a>
                </li>
              </ul>
            </li>
          </ul>

          <button type="button" class="btn-nav-close">
            <span class="txt-hide">전체보기 닫기</span>
          </button>
        </nav>
      </div>
    </div>
  </div>
  <!-- //header-area -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SiteHeader",
  //props: ["menuList"],
  data: function () {
    return {
      userMap: {},
      menu: null,
      loading: true,
      menus: [],
      menuList: [],
    };
  },
  created() {},
  watch: {
    menuList: function (to, from) {
      //this.getMenuScript();
      if (to != null && to.children != null) {
        this.loading = false;
        this.menus = to;
        this.getMenuScript();
      }
    },
  },
  methods: {
    setMenuList(menuList) {
      this.loading = false;
      if (menuList == null) return;

      this.menuList = menuList;
    },
    goMenu(item) {
      localStorage.setItem("MENU", item.id);
      this.$router.push(item.url).catch(() => {});
    },
    getMenuScript() {
      //func
      this.$nextTick(() => {
        $(".site-header").headerFunc();
        $(".site-gnb").gnbFunc();
        $(".site-nav-area").navFunc();
        $(".mn-top").mnTopFunc();
      });
    },
  },
  computed: {
    ...mapGetters(["routeParams", "currentUser", "currentMenu"]),
  },
};
</script>
